
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/more/contact",
      function () {
        return require("private-next-pages/more/contact.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/more/contact"])
      });
    }
  